export const host = 'https://api.www.gts56.com'
// export const host = 'http://192.168.1.117:1212'